export const DND_TYPES = {
  BOARD_CARD: 'BOARD_CARD'
};
export let INACTIVITY_UNITS;
(function (INACTIVITY_UNITS) {
  INACTIVITY_UNITS["DAYS"] = "days";
  INACTIVITY_UNITS["WEEKS"] = "weeks";
})(INACTIVITY_UNITS || (INACTIVITY_UNITS = {}));